import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const tagsImporterSelectors =
  importerSelectors('tags.importer')

export default tagsImporterSelectors
